import { QUERY_STRING_SET, QUERY_STRING_SET_REDUX } from "./queryStringActionConstants"

export const setQueryStringRedux = (payload) => ({
    type: QUERY_STRING_SET_REDUX,
    payload,
})
export const setQueryString = (payload) => ({
    type: QUERY_STRING_SET,
    payload,
})